import React, { useState } from 'react'
import DashboardLayout from '../../../components/layouts/dashboardLayout'
import { Row, Col, Icon, Modal } from 'antd';
import ActionButton from '../../../components/common/buttons/actionButton'

export default function ReserveTime() {
    const [addReserveModalVisible, setAddReserveModalVisible] = useState(false);
    const [reserveToday, setReserveToday] = useState(true);
    const [loadingPage , setLoadingPage] = useState(false);
    const [reservesData , setReservedData] = useState(false);

    const fetchReserves = async() => {
        setLoadingPage(true);
        
    }



    return (
        <DashboardLayout>
            <Modal
                visible={addReserveModalVisible}
                title={'ثبت رزرو زمان'}
                onOk={() => setAddReserveModalVisible(false)}
                onCancel={() => setAddReserveModalVisible(false)}
                footer={[
                    <div className="modalCdnteredFooter">
                        <ActionButton clickFunc={() => { setAddReserveModalVisible(false) }} theme={"dark"} icon={"check"} text={"ثبت درخواست"} />
                    </div>
                ]}
            >
                <div>
                    <Row>
                        <Col span={24}>
                            <h4 className={'normalText1'}>ثبت نوبت برای :</h4>
                        </Col>
                        <Col span={12} className={'flex-row-center-center'}>
                            <button className={"todayBtn"}>
                                فردا
                            </button>
                        </Col>
                        <Col span={12} className={'flex-row-center-center'}>
                            <button className={"todayBtn"}>
                                امروز
                            </button>
                        </Col>
                    </Row>
                </div>
            </Modal>
            <div className="site-layout-background" style={{ padding: 24 }}>
                <Row>
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                        <p className={"normalText1"}>سیستم نوبت‌گیری آنلاین</p>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                        <div className={"normalButtonWrapper darkBtn"}>
                            <button onClick={() => setAddReserveModalVisible(true)} className={"normalButton loginButton"}>
                                <div className="normalButtonInner">
                                    <div>
                                        <Icon type={'plus'} />
                                    </div>
                                    <p>گرفتن نوبت جدید</p>
                                </div>
                            </button>
                        </div>
                    </Col>
                    <Col span={24}>
                        {
                            JSON.stringify(reservesData)
                        }
                    </Col>
                </Row>
            </div>
        </DashboardLayout>
    )

}